__turbopack_context__.v({
  "mobileErrorMessage": "pjpSgq_mobileErrorMessage",
  "proceedButton": "pjpSgq_proceedButton",
  "tooltipContent": "pjpSgq_tooltipContent",
});
